import { Activity, User, Notification, AuditLog } from '../types'

export const currentUser: User = {
  id: 'u1',
  name: 'Kolonel Andi Pratama',
  username: 'andi.pratama',
  email: 'andi.pratama@ross.mil.id',
  role: 'Koordinator',
  unit: 'Safe House Cyber Command Center',
  isActive: true,
  lastLoginAt: '2026-03-06T08:00:00Z',
}

export const mockUsers: User[] = [
  currentUser,
  {
    id: 'u2',
    name: 'Mayor Budi Santoso',
    username: 'budi.s',
    email: 'budi@ross.mil.id',
    role: 'Operator',
    unit: 'Tim Operasi Siber',
    isActive: true,
    lastLoginAt: '2026-03-05T14:30:00Z',
  },
  {
    id: 'u3',
    name: 'Kapten Dewi Lestari',
    username: 'dewi.l',
    email: 'dewi@ross.mil.id',
    role: 'Operator',
    unit: 'Tim Analisis Ancaman',
    isActive: true,
    lastLoginAt: '2026-03-06T09:15:00Z',
  },
  {
    id: 'u4',
    name: 'Letkol Hendra Wijaya',
    username: 'hendra.w',
    email: 'hendra@ross.mil.id',
    role: 'Admin',
    unit: 'Staf Perencanaan',
    isActive: true,
    lastLoginAt: '2026-03-06T07:45:00Z',
  },
  {
    id: 'u5',
    name: 'Brigjen TNI Surya Darma',
    username: 'surya.d',
    email: 'surya@ross.mil.id',
    role: 'Viewer',
    unit: 'Komando Pusat',
    isActive: true,
    lastLoginAt: '2026-03-01T10:00:00Z',
  },
  {
    id: 'u6',
    name: 'Lettu Rina Amelia',
    username: 'rina.a',
    email: 'rina@ross.mil.id',
    role: 'Operator',
    unit: 'Tim Pertahanan Jaringan',
    isActive: true,
    lastLoginAt: '2026-03-06T11:20:00Z',
  },
  {
    id: 'u7',
    name: 'Mayor Czi Antonius',
    username: 'antonius',
    email: 'antonius@ross.mil.id',
    role: 'Koordinator',
    unit: 'Tim Intelijen Siber',
    isActive: false,
    lastLoginAt: '2026-02-15T08:00:00Z',
  },
  {
    id: 'u8',
    name: 'Kapten Inf Bayu Segara',
    username: 'bayu.s',
    email: 'bayu@ross.mil.id',
    role: 'Operator',
    unit: 'Tim Operasi Siber',
    isActive: true,
    lastLoginAt: '2026-03-06T13:10:00Z',
  },
]

export const mockActivities: Activity[] = [
  {
    id: 'act-001',
    code: 'OPS-SHCCC-20260301-001',
    title: 'Monitoring Pelaksanaan Operasi Pengamanan Wilayah Perbatasan',
    description:
      'Melakukan pemantauan intensif terhadap anomali trafik jaringan di wilayah perbatasan utara selama masa latihan gabungan.',
    category: 'Operasi',
    unit: 'Tim Operasi Siber',
    personInCharge: 'Mayor Budi Santoso',
    priority: 'Sangat Tinggi',
    status: 'Berjalan',
    classification: 'Rahasia',
    location: 'Command Center Ruang Alpha',
    startDate: '2026-03-01',
    dueDate: '2026-03-15',
    expectedOutput:
      'Laporan harian anomali trafik dan mitigasi ancaman real-time.',
    instructionReference: 'Surat Perintah Panglima No. Sprin/123/III/2026',
    createdBy: 'Kolonel Andi Pratama',
    createdAt: '2026-02-28T09:00:00Z',
    updatedAt: '2026-03-05T16:00:00Z',
    progressPercent: 45,
    members: [
      { id: 'm1', userId: 'u2', name: 'Mayor Budi Santoso', role: 'Ketua Tim' },
      {
        id: 'm2',
        userId: 'u8',
        name: 'Kapten Inf Bayu Segara',
        role: 'Analis Utama',
      },
    ],
    progressHistory: [
      {
        id: 'p1',
        activityId: 'act-001',
        progressPercent: 25,
        progressNote: 'Setup sensor di 5 titik perbatasan selesai.',
        obstacleNote: 'Cuaca buruk menghambat koneksi satelit di titik 3.',
        nextAction: 'Optimalisasi routing via fiber optik cadangan.',
        reportedBy: 'Mayor Budi Santoso',
        reportedAt: '2026-03-03T10:00:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Kolonel Andi Pratama',
        verifiedAt: '2026-03-03T14:00:00Z',
        verifierNote: 'Lanjutkan sesuai rencana, pantau titik 3.',
      },
      {
        id: 'p2',
        activityId: 'act-001',
        progressPercent: 45,
        progressNote: 'Monitoring berjalan stabil. Ditemukan 2 anomali minor.',
        obstacleNote: 'Nihil.',
        nextAction: 'Analisis log anomali.',
        reportedBy: 'Mayor Budi Santoso',
        reportedAt: '2026-03-05T15:30:00Z',
        verificationStatus: 'Belum Diverifikasi',
      },
    ],
    documents: [
      {
        id: 'd1',
        activityId: 'act-001',
        category: 'Surat Perintah',
        fileName: 'Sprin_123_III_2026.pdf',
        fileSize: '2.4 MB',
        mimeType: 'application/pdf',
        uploadedBy: 'Letkol Hendra Wijaya',
        uploadedAt: '2026-02-28T09:15:00Z',
        description: 'Surat Perintah Pelaksanaan Operasi',
      },
    ],
  },
  {
    id: 'act-002',
    code: 'OPS-SHCCC-20260220-002',
    title: 'Evaluasi Sistem Deteksi Ancaman Siber',
    description:
      'Mengevaluasi efektivitas IDS/IPS yang baru diimplementasikan pada jaringan inti komando.',
    category: 'Evaluasi',
    unit: 'Tim Analisis Ancaman',
    personInCharge: 'Kapten Dewi Lestari',
    priority: 'Tinggi',
    status: 'Menunggu Verifikasi',
    classification: 'Terbatas',
    location: 'Lab Siber Utama',
    startDate: '2026-02-20',
    dueDate: '2026-03-05',
    expectedOutput:
      'Dokumen hasil evaluasi dan rekomendasi tuning rule IDS/IPS.',
    instructionReference: 'Nota Dinas Asops No. ND/45/II/2026',
    createdBy: 'Letkol Hendra Wijaya',
    createdAt: '2026-02-19T11:00:00Z',
    updatedAt: '2026-03-06T08:00:00Z',
    progressPercent: 100,
    members: [
      {
        id: 'm3',
        userId: 'u3',
        name: 'Kapten Dewi Lestari',
        role: 'Lead Evaluator',
      },
    ],
    progressHistory: [
      {
        id: 'p3',
        activityId: 'act-002',
        progressPercent: 30,
        progressNote: 'Pengumpulan log dari 10 sensor utama selesai.',
        obstacleNote: 'Nihil.',
        nextAction: 'Mulai analisis false positive.',
        reportedBy: 'Kapten Dewi Lestari',
        reportedAt: '2026-02-25T09:00:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Letkol Hendra Wijaya',
        verifiedAt: '2026-02-25T13:00:00Z',
      },
      {
        id: 'p4',
        activityId: 'act-002',
        progressPercent: 70,
        progressNote: 'Analisis selesai. Ditemukan 15% false positive rate.',
        obstacleNote: 'Beberapa rule lama konflik dengan rule baru.',
        nextAction: 'Penyusunan rekomendasi tuning.',
        reportedBy: 'Kapten Dewi Lestari',
        reportedAt: '2026-03-02T11:30:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Letkol Hendra Wijaya',
        verifiedAt: '2026-03-02T15:00:00Z',
      },
      {
        id: 'p5',
        activityId: 'act-002',
        progressPercent: 100,
        progressNote: 'Laporan akhir dan rekomendasi selesai disusun.',
        obstacleNote: 'Nihil.',
        nextAction: 'Menunggu pengesahan untuk implementasi tuning.',
        reportedBy: 'Kapten Dewi Lestari',
        reportedAt: '2026-03-06T08:00:00Z',
        verificationStatus: 'Belum Diverifikasi',
      },
    ],
    documents: [
      {
        id: 'd2',
        activityId: 'act-002',
        category: 'Laporan',
        fileName: 'Laporan_Evaluasi_IDS.pdf',
        fileSize: '4.1 MB',
        mimeType: 'application/pdf',
        uploadedBy: 'Kapten Dewi Lestari',
        uploadedAt: '2026-03-06T08:05:00Z',
        description: 'Laporan Hasil Evaluasi IDS/IPS',
      },
      {
        id: 'd3',
        activityId: 'act-002',
        category: 'Teknis',
        fileName: 'Rekomendasi_Tuning_Rules.docx',
        fileSize: '1.2 MB',
        mimeType:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        uploadedBy: 'Kapten Dewi Lestari',
        uploadedAt: '2026-03-06T08:06:00Z',
        description: 'Daftar Rekomendasi Tuning Rule',
      },
    ],
  },
  {
    id: 'act-003',
    code: 'OPS-SHCCC-20260305-003',
    title: 'Koordinasi Kegiatan Patroli Siber Harian',
    description:
      'Rapat koordinasi harian untuk sinkronisasi target patroli siber di media sosial dan dark web.',
    category: 'Koordinasi',
    unit: 'Tim Intelijen Siber',
    personInCharge: 'Mayor Czi Antonius',
    priority: 'Sedang',
    status: 'Selesai',
    classification: 'Biasa',
    location: 'Ruang Rapat Yudha',
    startDate: '2026-03-05',
    dueDate: '2026-03-05',
    expectedOutput: 'Notulensi rapat dan pembagian sektor patroli.',
    instructionReference: 'SOP Patroli Harian',
    createdBy: 'Kolonel Andi Pratama',
    createdAt: '2026-03-04T16:00:00Z',
    updatedAt: '2026-03-05T17:00:00Z',
    progressPercent: 100,
    members: [],
    progressHistory: [
      {
        id: 'p6',
        activityId: 'act-003',
        progressPercent: 100,
        progressNote: 'Rapat selesai. Target patroli telah dibagikan ke 4 tim.',
        obstacleNote: 'Nihil.',
        nextAction: 'Pelaksanaan patroli oleh masing-masing tim.',
        reportedBy: 'Mayor Czi Antonius',
        reportedAt: '2026-03-05T10:00:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Kolonel Andi Pratama',
        verifiedAt: '2026-03-05T11:00:00Z',
      },
    ],
    documents: [
      {
        id: 'd4',
        activityId: 'act-003',
        category: 'Notulensi',
        fileName: 'Notulensi_Rapat_050326.pdf',
        fileSize: '0.8 MB',
        mimeType: 'application/pdf',
        uploadedBy: 'Mayor Czi Antonius',
        uploadedAt: '2026-03-05T10:15:00Z',
        description: 'Notulensi Rapat Koordinasi Patroli Siber',
      },
    ],
  },
  {
    id: 'act-004',
    code: 'OPS-SHCCC-20260215-004',
    title: 'Audit Keamanan Infrastruktur Jaringan Komando',
    description:
      'Audit menyeluruh terhadap topologi dan konfigurasi firewall di seluruh markas komando daerah.',
    category: 'Audit',
    unit: 'Tim Pertahanan Jaringan',
    personInCharge: 'Lettu Rina Amelia',
    priority: 'Tinggi',
    status: 'Tertunda',
    classification: 'Rahasia',
    location: 'Seluruh Kodam',
    startDate: '2026-02-15',
    dueDate: '2026-02-28',
    expectedOutput: 'Laporan Audit Keamanan Jaringan (LAKJ).',
    instructionReference: 'Sprin/88/II/2026',
    createdBy: 'Letkol Hendra Wijaya',
    createdAt: '2026-02-10T10:00:00Z',
    updatedAt: '2026-02-25T09:00:00Z',
    progressPercent: 60,
    members: [],
    progressHistory: [
      {
        id: 'p7',
        activityId: 'act-004',
        progressPercent: 30,
        progressNote: 'Audit selesai di 3 Kodam wilayah Barat.',
        obstacleNote: 'Nihil.',
        nextAction: 'Melanjutkan audit ke wilayah Tengah.',
        reportedBy: 'Lettu Rina Amelia',
        reportedAt: '2026-02-20T14:00:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Letkol Hendra Wijaya',
        verifiedAt: '2026-02-21T09:00:00Z',
      },
      {
        id: 'p8',
        activityId: 'act-004',
        progressPercent: 60,
        progressNote: 'Audit wilayah Tengah terhenti.',
        obstacleNote:
          'Tim dialihkan untuk penanganan insiden mendesak di Kodam V.',
        nextAction: 'Menunggu instruksi lanjutan untuk penjadwalan ulang.',
        reportedBy: 'Lettu Rina Amelia',
        reportedAt: '2026-02-25T08:30:00Z',
        verificationStatus: 'Belum Diverifikasi',
      },
    ],
    documents: [
      {
        id: 'd5',
        activityId: 'act-004',
        category: 'Teknis',
        fileName: 'Checklist_Audit_Firewall.xlsx',
        fileSize: '1.5 MB',
        mimeType:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        uploadedBy: 'Lettu Rina Amelia',
        uploadedAt: '2026-02-14T10:00:00Z',
        description: 'Template Checklist Audit Firewall',
      },
    ],
  },
  {
    id: 'act-005',
    code: 'OPS-SHCCC-20260310-005',
    title: 'Pelaksanaan Latihan Pertahanan Siber Terpadu',
    description:
      'Latihan simulasi serangan ransomware pada infrastruktur kritis dan prosedur pemulihannya.',
    category: 'Latihan',
    unit: 'Tim Operasi Siber',
    personInCharge: 'Mayor Budi Santoso',
    priority: 'Tinggi',
    status: 'Baru',
    classification: 'Terbatas',
    location: 'Pusat Simulasi Tempur',
    startDate: '2026-03-10',
    dueDate: '2026-03-12',
    expectedOutput:
      'Peningkatan kesiapan personel dalam menghadapi insiden siber.',
    instructionReference: 'Proker Tahunan 2026',
    createdBy: 'Kolonel Andi Pratama',
    createdAt: '2026-03-06T07:00:00Z',
    updatedAt: '2026-03-06T07:00:00Z',
    progressPercent: 0,
    members: [],
    progressHistory: [],
    documents: [
      {
        id: 'd6',
        activityId: 'act-005',
        category: 'Perencanaan',
        fileName: 'Rencana_Latihan_2026.pdf',
        fileSize: '3.2 MB',
        mimeType: 'application/pdf',
        uploadedBy: 'Kolonel Andi Pratama',
        uploadedAt: '2026-03-06T07:15:00Z',
        description: 'Dokumen Rencana Latihan Pertahanan Siber',
      },
    ],
  },
  {
    id: 'act-006',
    code: 'OPS-SHCCC-20260302-006',
    title: 'Pengembangan Kapabilitas Cyber Intelligence',
    description:
      'Integrasi platform OSINT baru ke dalam dashboard analitik utama.',
    category: 'Pengembangan',
    unit: 'Tim Intelijen Siber',
    personInCharge: 'Kapten Dewi Lestari',
    priority: 'Sedang',
    status: 'Berjalan',
    classification: 'Biasa',
    location: 'Ruang Pengembangan',
    startDate: '2026-03-02',
    dueDate: '2026-03-20',
    expectedOutput: 'Modul OSINT terintegrasi dan berfungsi penuh.',
    instructionReference: 'Renstra 2024-2029',
    createdBy: 'Letkol Hendra Wijaya',
    createdAt: '2026-03-01T08:00:00Z',
    updatedAt: '2026-03-06T10:00:00Z',
    progressPercent: 30,
    members: [],
    progressHistory: [
      {
        id: 'p9',
        activityId: 'act-006',
        progressPercent: 30,
        progressNote: 'API mapping dan arsitektur integrasi selesai.',
        obstacleNote:
          'Limitasi rate limit dari beberapa sumber data eksternal.',
        nextAction: 'Mulai coding backend integration.',
        reportedBy: 'Kapten Dewi Lestari',
        reportedAt: '2026-03-06T09:30:00Z',
        verificationStatus: 'Belum Diverifikasi',
      },
    ],
    documents: [
      {
        id: 'd7',
        activityId: 'act-006',
        category: 'Teknis',
        fileName: 'Spesifikasi_OSINT_Platform.pdf',
        fileSize: '5.5 MB',
        mimeType: 'application/pdf',
        uploadedBy: 'Kapten Dewi Lestari',
        uploadedAt: '2026-03-02T10:00:00Z',
        description: 'Spesifikasi Teknis Integrasi OSINT',
      },
    ],
  },
  {
    id: 'act-007',
    code: 'OPS-SHCCC-20260115-007',
    title: 'Pembaruan Protokol Enkripsi Komunikasi Taktis',
    description:
      'Migrasi algoritma enkripsi radio taktis ke standar AES-256 GCM.',
    category: 'Pengembangan',
    unit: 'Tim Pertahanan Jaringan',
    personInCharge: 'Lettu Rina Amelia',
    priority: 'Sangat Tinggi',
    status: 'Berjalan',
    classification: 'Sangat Rahasia',
    location: 'Lab Kriptografi',
    startDate: '2026-01-15',
    dueDate: '2026-03-01',
    expectedOutput: 'Seluruh perangkat radio taktis menggunakan protokol baru.',
    instructionReference: 'Direktif Sandi Negara',
    createdBy: 'Kolonel Andi Pratama',
    createdAt: '2026-01-10T09:00:00Z',
    updatedAt: '2026-03-02T14:00:00Z',
    progressPercent: 85,
    members: [],
    progressHistory: [
      {
        id: 'p10',
        activityId: 'act-007',
        progressPercent: 25,
        progressNote: 'Pengujian algoritma di lab selesai dengan sukses.',
        obstacleNote: 'Nihil.',
        nextAction: 'Mulai flashing firmware ke perangkat batch 1.',
        reportedBy: 'Lettu Rina Amelia',
        reportedAt: '2026-01-25T11:00:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Kolonel Andi Pratama',
        verifiedAt: '2026-01-26T09:00:00Z',
      },
      {
        id: 'p11',
        activityId: 'act-007',
        progressPercent: 60,
        progressNote: 'Flashing batch 1 dan 2 selesai (60% perangkat).',
        obstacleNote: 'Beberapa perangkat lama memerlukan upgrade hardware.',
        nextAction: 'Pengadaan komponen untuk perangkat lama.',
        reportedBy: 'Lettu Rina Amelia',
        reportedAt: '2026-02-15T14:30:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Kolonel Andi Pratama',
        verifiedAt: '2026-02-16T10:00:00Z',
      },
      {
        id: 'p12',
        activityId: 'act-007',
        progressPercent: 85,
        progressNote:
          'Batch 3 selesai. Sisa perangkat lama masih menunggu komponen.',
        obstacleNote: 'Keterlambatan pengiriman komponen dari vendor.',
        nextAction: 'Follow up vendor dan siapkan jadwal flashing susulan.',
        reportedBy: 'Lettu Rina Amelia',
        reportedAt: '2026-03-02T09:15:00Z',
        verificationStatus: 'Disetujui',
        verifiedBy: 'Kolonel Andi Pratama',
        verifiedAt: '2026-03-02T13:00:00Z',
      },
    ],
    documents: [
      {
        id: 'd8',
        activityId: 'act-007',
        category: 'Surat Perintah',
        fileName: 'Direktif_Sandi_Negara.pdf',
        fileSize: '1.8 MB',
        mimeType: 'application/pdf',
        uploadedBy: 'Kolonel Andi Pratama',
        uploadedAt: '2026-01-12T08:00:00Z',
        description: 'Direktif Pembaruan Standar Enkripsi',
      },
      {
        id: 'd9',
        activityId: 'act-007',
        category: 'Laporan',
        fileName: 'Laporan_Migrasi_Enkripsi.pdf',
        fileSize: '3.4 MB',
        mimeType: 'application/pdf',
        uploadedBy: 'Lettu Rina Amelia',
        uploadedAt: '2026-03-02T09:30:00Z',
        description: 'Laporan Progres Migrasi Enkripsi',
      },
    ],
  },
  {
    id: 'act-008',
    code: 'OPS-SHCCC-20260308-008',
    title: 'Penyusunan Laporan Bulanan Operasi Siber',
    description:
      'Rekapitulasi seluruh kegiatan operasi siber bulan Februari 2026.',
    category: 'Evaluasi',
    unit: 'Staf Perencanaan',
    personInCharge: 'Letkol Hendra Wijaya',
    priority: 'Rendah',
    status: 'Draft',
    classification: 'Biasa',
    location: 'Ruang Staf',
    startDate: '2026-03-08',
    dueDate: '2026-03-10',
    expectedOutput: 'Buku Laporan Bulanan.',
    instructionReference: 'SOP Pelaporan',
    createdBy: 'Letkol Hendra Wijaya',
    createdAt: '2026-03-06T11:00:00Z',
    updatedAt: '2026-03-06T11:00:00Z',
    progressPercent: 0,
    members: [],
  },
]

export const mockNotifications: Notification[] = [
  {
    id: 'n1',
    title: 'Kegiatan Overdue',
    message:
      'Kegiatan "Audit Keamanan Infrastruktur" telah melewati batas waktu.',
    type: 'error',
    isRead: false,
    createdAt: '2026-03-01T08:00:00Z',
  },
  {
    id: 'n2',
    title: 'Progres Menunggu Verifikasi',
    message:
      'Kapten Dewi Lestari melaporkan progres 100% pada "Evaluasi Sistem Deteksi".',
    type: 'warning',
    isRead: false,
    createdAt: '2026-03-06T08:05:00Z',
  },
  {
    id: 'n3',
    title: 'Kegiatan Baru Ditugaskan',
    message:
      'Anda ditugaskan pada "Pelaksanaan Latihan Pertahanan Siber Terpadu".',
    type: 'info',
    isRead: true,
    createdAt: '2026-03-06T07:05:00Z',
  },
  {
    id: 'n4',
    title: 'Dokumen Baru Diunggah',
    message:
      'Dokumen "Sprin_123_III_2026.pdf" ditambahkan ke OPS-SHCCC-20260301-001.',
    type: 'info',
    isRead: true,
    createdAt: '2026-02-28T09:20:00Z',
  },
  {
    id: 'n5',
    title: 'Progres Menunggu Verifikasi',
    message:
      'Mayor Budi Santoso melaporkan progres 45% pada "Monitoring Pelaksanaan Operasi".',
    type: 'warning',
    isRead: false,
    createdAt: '2026-03-05T15:35:00Z',
  },
  {
    id: 'n6',
    title: 'Progres Menunggu Verifikasi',
    message:
      'Kapten Dewi Lestari melaporkan progres 30% pada "Pengembangan Kapabilitas Cyber Intelligence".',
    type: 'warning',
    isRead: false,
    createdAt: '2026-03-06T09:35:00Z',
  },
  {
    id: 'n7',
    title: 'Dokumen Baru Diunggah',
    message:
      'Dokumen "Laporan_Evaluasi_IDS.pdf" ditambahkan ke OPS-SHCCC-20260220-002.',
    type: 'info',
    isRead: false,
    createdAt: '2026-03-06T08:10:00Z',
  },
  {
    id: 'n8',
    title: 'Kegiatan Selesai',
    message:
      'Kegiatan "Koordinasi Kegiatan Patroli Siber Harian" telah diselesaikan.',
    type: 'success',
    isRead: true,
    createdAt: '2026-03-05T17:05:00Z',
  },
]

export const mockAuditLogs: AuditLog[] = [
  {
    id: 'al1',
    userId: 'u2',
    userName: 'Mayor Budi Santoso',
    action: 'Tambah Progres',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260301-001',
    ipAddress: '10.0.5.22',
    createdAt: '2026-03-05T15:30:00Z',
  },
  {
    id: 'al2',
    userId: 'u1',
    userName: 'Kolonel Andi Pratama',
    action: 'Login',
    module: 'Auth',
    objectId: '-',
    ipAddress: '10.0.1.15',
    createdAt: '2026-03-06T08:00:00Z',
  },
  {
    id: 'al3',
    userId: 'u4',
    userName: 'Letkol Hendra Wijaya',
    action: 'Buat Kegiatan',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260308-008',
    ipAddress: '10.0.2.44',
    createdAt: '2026-03-06T11:00:00Z',
  },
  {
    id: 'al4',
    userId: 'u3',
    userName: 'Kapten Dewi Lestari',
    action: 'Ubah Status',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260220-002',
    ipAddress: '10.0.3.12',
    createdAt: '2026-03-06T08:00:00Z',
  },
  {
    id: 'al5',
    userId: 'u1',
    userName: 'Kolonel Andi Pratama',
    action: 'Verifikasi Progres',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260301-001',
    ipAddress: '10.0.1.15',
    createdAt: '2026-03-03T14:00:00Z',
  },
  {
    id: 'al6',
    userId: 'u3',
    userName: 'Kapten Dewi Lestari',
    action: 'Upload Dokumen',
    module: 'Dokumen',
    objectId: 'd2',
    ipAddress: '10.0.3.12',
    createdAt: '2026-03-06T08:05:00Z',
  },
  {
    id: 'al7',
    userId: 'u3',
    userName: 'Kapten Dewi Lestari',
    action: 'Upload Dokumen',
    module: 'Dokumen',
    objectId: 'd3',
    ipAddress: '10.0.3.12',
    createdAt: '2026-03-06T08:06:00Z',
  },
  {
    id: 'al8',
    userId: 'u3',
    userName: 'Kapten Dewi Lestari',
    action: 'Tambah Progres',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260302-006',
    ipAddress: '10.0.3.12',
    createdAt: '2026-03-06T09:30:00Z',
  },
  {
    id: 'al9',
    userId: 'u7',
    userName: 'Mayor Czi Antonius',
    action: 'Tambah Progres',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260305-003',
    ipAddress: '10.0.4.18',
    createdAt: '2026-03-05T10:00:00Z',
  },
  {
    id: 'al10',
    userId: 'u1',
    userName: 'Kolonel Andi Pratama',
    action: 'Verifikasi Progres',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260305-003',
    ipAddress: '10.0.1.15',
    createdAt: '2026-03-05T11:00:00Z',
  },
  {
    id: 'al11',
    userId: 'u6',
    userName: 'Lettu Rina Amelia',
    action: 'Login',
    module: 'Auth',
    objectId: '-',
    ipAddress: '10.0.6.33',
    createdAt: '2026-03-06T11:20:00Z',
  },
  {
    id: 'al12',
    userId: 'u4',
    userName: 'Letkol Hendra Wijaya',
    action: 'Edit Kegiatan',
    module: 'Kegiatan',
    objectId: 'OPS-SHCCC-20260215-004',
    ipAddress: '10.0.2.44',
    createdAt: '2026-02-25T09:00:00Z',
  },
  {
    id: 'log-012',
    userId: 'usr-005',
    userName: 'Surya',
    action: 'LOGIN',
    module: 'AUTH',
    objectId: '-',
    ipAddress: '192.168.1.110',
    createdAt: new Date(Date.now() - 3600000 * 24).toISOString(),
  },
]

export const mockProTasks: import('../types').ProTask[] = [
  {
    id: 'pro-001',
    code: 'PRO-2026-001',
    title: 'Amplifikasi Kebijakan Cyber Defense Nasional',
    description:
      'Meningkatkan awareness publik terkait kebijakan pertahanan siber baru melalui thread edukatif.',
    platform: 'Twitter/X',
    contentType: 'Thread',
    narrativeAngle: 'Ketahanan Nasional & Keamanan Data',
    targetReach: 500000,
    achievedReach: 125000,
    assets: ['https://example.com/asset1.jpg'],
    priority: 'Tinggi',
    status: 'Berjalan',
    personInCharge: 'Andi Pratama',
    unit: 'Safe House Cyber Command Center',
    startDate: new Date(Date.now() - 86400000 * 2).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 5).toISOString(),
    createdAt: new Date(Date.now() - 86400000 * 3).toISOString(),
  },
  {
    id: 'pro-002',
    code: 'PRO-2026-002',
    title: 'Hashtag Campaign #JagaNKRI',
    description:
      'Kampanye serentak untuk menaikkan trending topic positif di akhir pekan.',
    platform: 'Multi-Platform',
    contentType: 'Post',
    narrativeAngle: 'Persatuan & Kesatuan',
    targetReach: 1000000,
    achievedReach: 0,
    assets: [],
    priority: 'Sangat Tinggi',
    status: 'Direncanakan',
    personInCharge: 'Budi Santoso',
    unit: 'Divisi Operasi',
    startDate: new Date(Date.now() + 86400000 * 1).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 3).toISOString(),
    createdAt: new Date(Date.now() - 86400000 * 1).toISOString(),
  },
  {
    id: 'pro-003',
    code: 'PRO-2026-003',
    title: 'Counter-narasi Stabilitas Politik',
    description:
      'Menyebarkan video pendek yang menjelaskan fakta sebenarnya terkait isu politik terkini.',
    platform: 'TikTok',
    contentType: 'Video',
    narrativeAngle: 'Fakta & Klarifikasi',
    targetReach: 2000000,
    achievedReach: 2150000,
    assets: ['https://example.com/vid1.mp4'],
    priority: 'Tinggi',
    status: 'Selesai',
    personInCharge: 'Dewi Lestari',
    unit: 'Divisi Analisis',
    startDate: new Date(Date.now() - 86400000 * 10).toISOString(),
    dueDate: new Date(Date.now() - 86400000 * 2).toISOString(),
    createdAt: new Date(Date.now() - 86400000 * 12).toISOString(),
  },
  {
    id: 'pro-004',
    code: 'PRO-2026-004',
    title: 'Dukungan Program Literasi Digital',
    description:
      'Blasting komentar positif pada postingan kementerian terkait literasi digital.',
    platform: 'Instagram',
    contentType: 'Comment',
    narrativeAngle: 'Dukungan & Apresiasi',
    targetReach: 50000,
    achievedReach: 0,
    assets: [],
    priority: 'Sedang',
    status: 'Draft',
    personInCharge: 'Hendra Wijaya',
    unit: 'Divisi Operasi',
    startDate: new Date(Date.now() + 86400000 * 5).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 10).toISOString(),
    createdAt: new Date().toISOString(),
  },
]

export const mockKontraTasks: import('../types').KontraTask[] = [
  {
    id: 'ktr-001',
    code: 'KTR-2026-001',
    title: 'Takedown Video Disinformasi Pilkada',
    description:
      'Mengajukan takedown request untuk video YouTube yang mengandung ujaran kebencian dan hoaks.',
    targetUrl: 'https://youtube.com/watch?v=xxxx',
    targetPlatform: 'YouTube',
    actionType: 'Takedown',
    threatLevel: 'Kritis',
    justification: 'Melanggar UU ITE pasal 28 ayat 2 (Ujaran Kebencian SARA)',
    priority: 'Sangat Tinggi',
    status: 'Berjalan',
    personInCharge: 'Surya Dharma',
    unit: 'Safe House Cyber Command Center',
    startDate: new Date(Date.now() - 86400000 * 1).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 1).toISOString(),
    createdAt: new Date(Date.now() - 86400000 * 1).toISOString(),
  },
  {
    id: 'ktr-002',
    code: 'KTR-2026-002',
    title: 'Counter-Blast Akun Provokator @anon_id',
    description:
      'Mengerahkan pasukan siber untuk membanjiri kolom komentar dengan fakta dan menenggelamkan narasi provokator.',
    targetUrl: 'https://twitter.com/anon_id/status/123456',
    targetPlatform: 'Twitter/X',
    actionType: 'Counter Blast',
    threatLevel: 'Tinggi',
    justification: 'Mencegah eskalasi kepanikan massa di platform X',
    priority: 'Tinggi',
    status: 'Direncanakan',
    personInCharge: 'Rina Melati',
    unit: 'Divisi Operasi',
    startDate: new Date(Date.now() + 86400000 * 1).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 2).toISOString(),
    createdAt: new Date().toISOString(),
  },
  {
    id: 'ktr-003',
    code: 'KTR-2026-003',
    title: 'Mass Report Forum Radikal',
    description:
      'Melakukan mass report terhadap grup Facebook yang terindikasi menyebarkan paham radikalisme.',
    targetUrl: 'https://facebook.com/groups/xxxx',
    targetPlatform: 'Facebook',
    actionType: 'Mass Report',
    threatLevel: 'Kritis',
    justification: 'Penyebaran ideologi terlarang dan rekrutmen',
    priority: 'Sangat Tinggi',
    status: 'Selesai',
    personInCharge: 'Antonius',
    unit: 'Divisi Analisis',
    startDate: new Date(Date.now() - 86400000 * 5).toISOString(),
    dueDate: new Date(Date.now() - 86400000 * 1).toISOString(),
    resolution: 'Grup berhasil ditakedown oleh pihak Meta dalam waktu 48 jam.',
    createdAt: new Date(Date.now() - 86400000 * 6).toISOString(),
  },
  {
    id: 'ktr-004',
    code: 'KTR-2026-004',
    title: 'Counter Comment Berita Miring',
    description:
      'Memberikan klarifikasi resmi di kolom komentar portal berita online.',
    targetUrl: 'https://news-site.com/article/123',
    targetPlatform: 'News Site',
    actionType: 'Counter Comment',
    threatLevel: 'Sedang',
    justification: 'Meluruskan misinformasi terkait anggaran pertahanan',
    priority: 'Sedang',
    status: 'Draft',
    personInCharge: 'Andi Pratama',
    unit: 'Safe House Cyber Command Center',
    startDate: new Date(Date.now() + 86400000 * 2).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 3).toISOString(),
    createdAt: new Date().toISOString(),
  },
]

export const mockOsintTasks: import('../types').OsintTask[] = [
  {
    id: 'ost-001',
    code: 'OSINT-2026-001',
    title: 'Profiling Akun Anonim Penyebar Hoax',
    subjectName: '@anon_provokator',
    subjectType: 'Account',
    description:
      'Melakukan identifikasi pemilik asli di balik akun anonim yang sering menyebarkan hoaks terkait pemerintah.',
    dataSources: ['Twitter/X', 'Telegram', 'Breached Database'],
    classification: 'Restricted',
    findings:
      'Terindikasi dioperasikan oleh sindikat buzzer komersial yang berlokasi di luar negeri.',
    priority: 'Tinggi',
    status: 'Berjalan',
    personInCharge: 'Bayu',
    unit: 'Divisi Analisis',
    startDate: new Date(Date.now() - 86400000 * 3).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 4).toISOString(),
    createdAt: new Date(Date.now() - 86400000 * 4).toISOString(),
  },
  {
    id: 'ost-002',
    code: 'OSINT-2026-002',
    title: 'Network Mapping Cluster Disinformasi',
    subjectName: 'Cluster X-19',
    subjectType: 'Network',
    description:
      'Memetakan jaringan akun-akun bot yang saling meretweet narasi anti-pemerintah.',
    dataSources: ['Twitter/X API', 'Gephi Analysis'],
    classification: 'Confidential',
    findings:
      'Terdapat 3 akun master yang mengendalikan lebih dari 500 akun bot.',
    priority: 'Sangat Tinggi',
    status: 'Selesai',
    personInCharge: 'Dewi Lestari',
    unit: 'Divisi Analisis',
    startDate: new Date(Date.now() - 86400000 * 14).toISOString(),
    dueDate: new Date(Date.now() - 86400000 * 2).toISOString(),
    createdAt: new Date(Date.now() - 86400000 * 15).toISOString(),
  },
  {
    id: 'ost-003',
    code: 'OSINT-2026-003',
    title: 'Profil Tokoh Target X',
    subjectName: 'Target X (Redacted)',
    subjectType: 'Person',
    description:
      'Mengumpulkan rekam jejak digital dan afiliasi politik dari tokoh yang dicurigai mendanai aksi massa.',
    dataSources: ['LinkedIn', 'Public Company Records', 'News Archives'],
    classification: 'Secret',
    findings: 'Dalam proses pengumpulan data awal.',
    priority: 'Tinggi',
    status: 'Direncanakan',
    personInCharge: 'Andi Pratama',
    unit: 'Safe House Cyber Command Center',
    startDate: new Date(Date.now() + 86400000 * 1).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 10).toISOString(),
    createdAt: new Date().toISOString(),
  },
  {
    id: 'ost-004',
    code: 'OSINT-2026-004',
    title: 'Analisis Pendanaan Organisasi Y',
    subjectName: 'Organisasi Y',
    subjectType: 'Organization',
    description:
      'Melacak aliran dana kampanye hitam melalui open source intelligence.',
    dataSources: ['Crypto Ledgers', 'Dark Web Forums', 'Corporate Registries'],
    classification: 'Secret',
    findings: '',
    priority: 'Sangat Tinggi',
    status: 'Draft',
    personInCharge: 'Surya Dharma',
    unit: 'Safe House Cyber Command Center',
    startDate: new Date(Date.now() + 86400000 * 5).toISOString(),
    dueDate: new Date(Date.now() + 86400000 * 20).toISOString(),
    createdAt: new Date().toISOString(),
  },
]
